import React from 'react';
import { PermissionListPage } from './list';

export const PermissionsModule = () => {
  return <PermissionListPage />;
};
